// Функции получения справочников из базы и конвертации их в options для Select

import { message } from "antd"
import { serverFetch } from "../server"

// okFunc - функция, вызываемая в случае успеха (setState). Параметры полученный набор

// Преобразование справочника id,name в options для Select
export const dictsDictionary2Options = items => items.map(i => ({value: i.id, label: i.name, ...i}));

const getItemsFromApi = (okFunc, controller) => {
  serverFetch(controller)
    .then(data => okFunc(dictsDictionary2Options(data)))
    .catch(e => message.error(e.userMessage));
}

export const dictsGetUsers = (okFunc, { activeOnly = false } = {}) => getItemsFromApi(okFunc, activeOnly ? "User?activeOnly=true" : "User")


export const dictsGetPaymentVids = okFunc => getItemsFromApi(okFunc, "paymentvid")

export const dictsGetCalendars = okFunc => getItemsFromApi(okFunc, "calendar")

export const dictsGetRooms = okFunc => getItemsFromApi(okFunc, "room")

/** Получить номенклатуру с указанным видом только активную. 
*   Вы выборку добавлены label и value для использования в Select 
*   @param {func} okFunc калбэк функция, вызываемая в случае удачи
*   @param {int} vid вид типа номенклатуры
*/
export const dictsGetProductsForSale = (okFunc, vid) => {
  serverFetch(`product/ForSale?vid=${vid}&active=true`)
    .then(data => okFunc(data.map(i => ({ value: i.id, label: i.name, ...i }))))
    .catch(e => message.error(e.userMessage));
}

export const distsKKMTags1212 = [
  {value: 0, label: " "},
  {value: 1, label: "Товар"},
  {value: 3, label: "Работа"},
  {value: 4, label: "Услуга"},
  {value: 33, label: "Маркированный товар"},
]

export const dictsReportVids = [
  {value: 1, label: "Клиент"},
  {value: 4, label: "Абонемент клиента"},
  {value: 2, label: "Запись"},
  {value: 3, label: "Визит"},
  {value: 5, label: "Накладные"},
  {value: 6, label: "Склад - ОСВ"},
  {value: 7, label: "Накладная"},
  {value: 8, label: "Реестр"},
  {value: 9, label: "Покупки лицензий"},
]

export const dictsReportVidName = value => dictsReportVids.find(i => i.value === value)?.label;

/** Виды каналов связи (мессенджеры, телефон, чат на сайте) */
export const dictsChannelVids = [
  { value: 1, label: "Телеграм" },
  // { value: 2, label: "WhatsApp" },
  { value: 3, label: "Max" },
  { value: 5, label: "Vk" },
  // { value: 4, label: "SMS" },
  // { value: 101, label: "Телефон" },
  { value: 201, label: "Чат на сайте" },
];

export const dictsChannelVidName = value => dictsChannelVids.find(i => i.value === value)?.label ?? value;

export const userOptionsWithPosition = (users) => (users ?? []).map(u => ({
  value: u.value,
  label: (
    <div>
      <div>{u.name ?? u.label}</div>
      {u.position && <div style={{ fontSize: "12px", color: "#999" }}>{u.position}</div>}
    </div>
  ),
  title: u.name ?? u.label,
  disabled: u.disabled,
}));